import { Route, Routes} from 'react-router-dom'
import app from './App.module.scss'
import Main from '../../pages/Main/Main'
import Header  from '../Header/Header'
import Footer  from '../Footer/Footer'
import UpButton from '../UpButton/UpButton'

function App() {
  
  const vh = window.innerHeight / 100;
  document.documentElement.style.setProperty('--vh', `${vh}px`);




  return (
    <div className={app.page}>
      <Header
      />
      <Routes> 
        <Route  path='/'  element={
          <Main
          />
        }/>
      </Routes>
      <Footer
      />  
      <UpButton/>
    </div>
  );
}

export default App;
